import { DEFAULT_FETCHING_STATE, DEFAULT_NO_ERROR } from "state/constants";
import Types from "./types";

const INITIAL_STATE = {
    stats: {
        totalUsers: 0,
        totalTherapists: 0,
        totalAppointments: 0,
        totalRevenue: 0,
        appointmentsByMonth: [],
    },
    users: {
        data: [],
        total: 0,
        page: 1,
        limit: 10,
    },
    pendingTherapists: [],
    therapists: { list: [], total: 0, page: 1, pages: 1 },
    currentUser: null,
    reviews: {
        data: [],
        total: 0,
        page: 1,
        limit: 10,
    },
    businesses: {
        data: [],
        total: 0,
        page: 1,
        limit: 20,
    },
    currentBusiness: null,
    fetching: {
        stats: { ...DEFAULT_FETCHING_STATE },
        users: { ...DEFAULT_FETCHING_STATE },
        userById: { ...DEFAULT_FETCHING_STATE },
        updateUser: { ...DEFAULT_FETCHING_STATE },
        deleteUser: { ...DEFAULT_FETCHING_STATE },
        toggleUserStatus: { ...DEFAULT_FETCHING_STATE },
        resetUserPassword: { ...DEFAULT_FETCHING_STATE },
        pendingTherapists: { ...DEFAULT_FETCHING_STATE },
        approveTherapist: { ...DEFAULT_FETCHING_STATE },
        rejectTherapist: { ...DEFAULT_FETCHING_STATE },
        reviews: { ...DEFAULT_FETCHING_STATE },
        moderateReview: { ...DEFAULT_FETCHING_STATE },
        businesses: { ...DEFAULT_FETCHING_STATE },
        businessById: { ...DEFAULT_FETCHING_STATE },
        updateBusiness: { ...DEFAULT_FETCHING_STATE },
        updateBusinessStatus: { ...DEFAULT_FETCHING_STATE },
        createBusiness: { ...DEFAULT_FETCHING_STATE },
        deleteBusiness: { ...DEFAULT_FETCHING_STATE },
        bulkDeleteBusinesses: { ...DEFAULT_FETCHING_STATE },
        bulkUpdateBusinessStatus: { ...DEFAULT_FETCHING_STATE },
        bulkDeleteUsers: { ...DEFAULT_FETCHING_STATE },
        bulkToggleUsers: { ...DEFAULT_FETCHING_STATE },
        createUser: { ...DEFAULT_FETCHING_STATE },
        restoreUser: { ...DEFAULT_FETCHING_STATE },
        therapists: { ...DEFAULT_FETCHING_STATE },
    },
    error: { ...DEFAULT_NO_ERROR },
};

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        // FETCH STATS
        case Types.FETCH_STATS_START:
            return {
                ...state,
                fetching: {
                    ...state.fetching,
                    stats: { ...DEFAULT_FETCHING_STATE, state: true },
                },
            };
        case Types.FETCH_STATS_SUCCESS:
            return {
                ...state,
                stats: action.payload,
                fetching: {
                    ...state.fetching,
                    stats: { ...DEFAULT_FETCHING_STATE },
                },
                error: { ...DEFAULT_NO_ERROR },
            };
        case Types.FETCH_STATS_ERROR:
            return {
                ...state,
                fetching: {
                    ...state.fetching,
                    stats: { ...DEFAULT_FETCHING_STATE },
                },
                error: { timestamp: Date.now(), message: action.payload },
            };

        // FETCH USERS
        case Types.FETCH_USERS_START:
            return {
                ...state,
                fetching: {
                    ...state.fetching,
                    users: { ...DEFAULT_FETCHING_STATE, state: true },
                },
            };
        case Types.FETCH_USERS_SUCCESS:
            return {
                ...state,
                users: {
                    data: action.payload.users || [],
                    total: action.payload.pagination?.total || 0,
                    page: action.payload.pagination?.page || 1,
                    limit: action.payload.pagination?.limit || 10,
                },
                fetching: {
                    ...state.fetching,
                    users: { ...DEFAULT_FETCHING_STATE },
                },
                error: { ...DEFAULT_NO_ERROR },
            };
        case Types.FETCH_USERS_ERROR:
            return {
                ...state,
                fetching: {
                    ...state.fetching,
                    users: { ...DEFAULT_FETCHING_STATE },
                },
                error: { timestamp: Date.now(), message: action.payload },
            };

        // FETCH USER BY ID
        case Types.FETCH_USER_BY_ID_START:
            return {
                ...state,
                fetching: {
                    ...state.fetching,
                    userById: { ...DEFAULT_FETCHING_STATE, state: true },
                },
            };
        case Types.FETCH_USER_BY_ID_SUCCESS:
            return {
                ...state,
                currentUser: action.payload,
                fetching: {
                    ...state.fetching,
                    userById: { ...DEFAULT_FETCHING_STATE },
                },
                error: { ...DEFAULT_NO_ERROR },
            };
        case Types.FETCH_USER_BY_ID_ERROR:
            return {
                ...state,
                fetching: {
                    ...state.fetching,
                    userById: { ...DEFAULT_FETCHING_STATE },
                },
                error: { timestamp: Date.now(), message: action.payload },
            };

        // FETCH PENDING THERAPISTS
        case Types.FETCH_PENDING_THERAPISTS_START:
            return {
                ...state,
                fetching: { ...state.fetching, pendingTherapists: { ...DEFAULT_FETCHING_STATE, state: true } },
            };
        case Types.FETCH_PENDING_THERAPISTS_SUCCESS:
            return {
                ...state,
                pendingTherapists: action.payload.therapists || [],
                fetching: { ...state.fetching, pendingTherapists: { ...DEFAULT_FETCHING_STATE } },
                error: { ...DEFAULT_NO_ERROR },
            };
        case Types.FETCH_PENDING_THERAPISTS_ERROR:
            return {
                ...state,
                fetching: { ...state.fetching, pendingTherapists: { ...DEFAULT_FETCHING_STATE } },
                error: { timestamp: Date.now(), message: action.payload },
            };

        // USER CRUD
        case Types.UPDATE_USER_START:
            return { ...state, fetching: { ...state.fetching, updateUser: { ...DEFAULT_FETCHING_STATE, state: true } } };
        case Types.UPDATE_USER_SUCCESS:
            return { ...state, fetching: { ...state.fetching, updateUser: { ...DEFAULT_FETCHING_STATE } }, error: { ...DEFAULT_NO_ERROR } };
        case Types.UPDATE_USER_ERROR:
            return { ...state, fetching: { ...state.fetching, updateUser: { ...DEFAULT_FETCHING_STATE } }, error: { timestamp: Date.now(), message: action.payload } };

        case Types.DELETE_USER_START:
            return { ...state, fetching: { ...state.fetching, deleteUser: { ...DEFAULT_FETCHING_STATE, state: true } } };
        case Types.DELETE_USER_SUCCESS:
            return { ...state, fetching: { ...state.fetching, deleteUser: { ...DEFAULT_FETCHING_STATE } }, error: { ...DEFAULT_NO_ERROR } };
        case Types.DELETE_USER_ERROR:
            return { ...state, fetching: { ...state.fetching, deleteUser: { ...DEFAULT_FETCHING_STATE } }, error: { timestamp: Date.now(), message: action.payload } };

        case Types.TOGGLE_USER_STATUS_START:
            return { ...state, fetching: { ...state.fetching, toggleUserStatus: { ...DEFAULT_FETCHING_STATE, state: true } } };
        case Types.TOGGLE_USER_STATUS_SUCCESS:
            return { ...state, fetching: { ...state.fetching, toggleUserStatus: { ...DEFAULT_FETCHING_STATE } }, error: { ...DEFAULT_NO_ERROR } };
        case Types.TOGGLE_USER_STATUS_ERROR:
            return { ...state, fetching: { ...state.fetching, toggleUserStatus: { ...DEFAULT_FETCHING_STATE } }, error: { timestamp: Date.now(), message: action.payload } };

        case Types.RESET_USER_PASSWORD_START:
            return { ...state, fetching: { ...state.fetching, resetUserPassword: { ...DEFAULT_FETCHING_STATE, state: true } } };
        case Types.RESET_USER_PASSWORD_SUCCESS:
            return { ...state, fetching: { ...state.fetching, resetUserPassword: { ...DEFAULT_FETCHING_STATE } }, error: { ...DEFAULT_NO_ERROR } };
        case Types.RESET_USER_PASSWORD_ERROR:
            return { ...state, fetching: { ...state.fetching, resetUserPassword: { ...DEFAULT_FETCHING_STATE } }, error: { timestamp: Date.now(), message: action.payload } };

        // APPROVE THERAPIST
        case Types.APPROVE_THERAPIST_START:
            return {
                ...state,
                fetching: {
                    ...state.fetching,
                    approveTherapist: { ...DEFAULT_FETCHING_STATE, state: true },
                },
            };
        case Types.APPROVE_THERAPIST_SUCCESS:
            return {
                ...state,
                fetching: {
                    ...state.fetching,
                    approveTherapist: { ...DEFAULT_FETCHING_STATE },
                },
                error: { ...DEFAULT_NO_ERROR },
            };
        case Types.APPROVE_THERAPIST_ERROR:
            return {
                ...state,
                fetching: {
                    ...state.fetching,
                    approveTherapist: { ...DEFAULT_FETCHING_STATE },
                },
                error: { timestamp: Date.now(), message: action.payload },
            };

        // REJECT THERAPIST
        case Types.REJECT_THERAPIST_START:
            return {
                ...state,
                fetching: {
                    ...state.fetching,
                    rejectTherapist: { ...DEFAULT_FETCHING_STATE, state: true },
                },
            };
        case Types.REJECT_THERAPIST_SUCCESS:
            return {
                ...state,
                fetching: {
                    ...state.fetching,
                    rejectTherapist: { ...DEFAULT_FETCHING_STATE },
                },
                error: { ...DEFAULT_NO_ERROR },
            };
        case Types.REJECT_THERAPIST_ERROR:
            return {
                ...state,
                fetching: {
                    ...state.fetching,
                    rejectTherapist: { ...DEFAULT_FETCHING_STATE },
                },
                error: { timestamp: Date.now(), message: action.payload },
            };

        // FETCH THERAPISTS (all, filterable)
        case Types.FETCH_THERAPISTS_START:
            return { ...state, fetching: { ...state.fetching, therapists: { ...DEFAULT_FETCHING_STATE, state: true } } };
        case Types.FETCH_THERAPISTS_SUCCESS:
            return {
                ...state,
                therapists: {
                    list:  action.payload.therapists || [],
                    total: action.payload.total  || 0,
                    page:  action.payload.page   || 1,
                    pages: action.payload.pages  || 1,
                },
                fetching: { ...state.fetching, therapists: { ...DEFAULT_FETCHING_STATE } },
                error: { ...DEFAULT_NO_ERROR },
            };
        case Types.FETCH_THERAPISTS_FAIL:
            return {
                ...state,
                fetching: { ...state.fetching, therapists: { ...DEFAULT_FETCHING_STATE, error: action.payload } },
                error: { timestamp: Date.now(), message: action.payload },
            };

        // FETCH REVIEWS
        case Types.FETCH_REVIEWS_START:
            return {
                ...state,
                fetching: {
                    ...state.fetching,
                    reviews: { ...DEFAULT_FETCHING_STATE, state: true },
                },
            };
        case Types.FETCH_REVIEWS_SUCCESS:
            return {
                ...state,
                reviews: action.payload,
                fetching: {
                    ...state.fetching,
                    reviews: { ...DEFAULT_FETCHING_STATE },
                },
                error: { ...DEFAULT_NO_ERROR },
            };
        case Types.FETCH_REVIEWS_ERROR:
            return {
                ...state,
                fetching: {
                    ...state.fetching,
                    reviews: { ...DEFAULT_FETCHING_STATE },
                },
                error: { timestamp: Date.now(), message: action.payload },
            };

        // MODERATE REVIEW
        case Types.MODERATE_REVIEW_START:
            return {
                ...state,
                fetching: {
                    ...state.fetching,
                    moderateReview: { ...DEFAULT_FETCHING_STATE, state: true },
                },
            };
        case Types.MODERATE_REVIEW_SUCCESS:
            return {
                ...state,
                fetching: {
                    ...state.fetching,
                    moderateReview: { ...DEFAULT_FETCHING_STATE },
                },
                error: { ...DEFAULT_NO_ERROR },
            };
        case Types.MODERATE_REVIEW_ERROR:
            return {
                ...state,
                fetching: {
                    ...state.fetching,
                    moderateReview: { ...DEFAULT_FETCHING_STATE },
                },
                error: { timestamp: Date.now(), message: action.payload },
            };

        case Types.RESET_ERROR:
            return {
                ...state,
                error: { ...DEFAULT_NO_ERROR },
            };

        // BUSINESSES
        case Types.FETCH_BUSINESSES_START:
            return { ...state, fetching: { ...state.fetching, businesses: { ...DEFAULT_FETCHING_STATE, state: true } } };
        case Types.FETCH_BUSINESSES_SUCCESS:
            return {
                ...state,
                businesses: {
                    data: action.payload.businesses || [],
                    total: action.payload.pagination?.total || 0,
                    page: action.payload.pagination?.page || 1,
                    limit: action.payload.pagination?.limit || 20,
                },
                fetching: { ...state.fetching, businesses: { ...DEFAULT_FETCHING_STATE } },
                error: { ...DEFAULT_NO_ERROR },
            };
        case Types.FETCH_BUSINESSES_ERROR:
            return { ...state, fetching: { ...state.fetching, businesses: { ...DEFAULT_FETCHING_STATE } }, error: { timestamp: Date.now(), message: action.payload } };

        case Types.FETCH_BUSINESS_BY_ID_START:
            return { ...state, fetching: { ...state.fetching, businessById: { ...DEFAULT_FETCHING_STATE, state: true } } };
        case Types.FETCH_BUSINESS_BY_ID_SUCCESS:
            return {
                ...state,
                currentBusiness: action.payload,
                fetching: { ...state.fetching, businessById: { ...DEFAULT_FETCHING_STATE } },
                error: { ...DEFAULT_NO_ERROR },
            };
        case Types.FETCH_BUSINESS_BY_ID_ERROR:
            return { ...state, fetching: { ...state.fetching, businessById: { ...DEFAULT_FETCHING_STATE } }, error: { timestamp: Date.now(), message: action.payload } };

        case Types.UPDATE_BUSINESS_START:
            return { ...state, fetching: { ...state.fetching, updateBusiness: { ...DEFAULT_FETCHING_STATE, state: true } } };
        case Types.UPDATE_BUSINESS_SUCCESS:
            return {
                ...state,
                currentBusiness: action.payload,
                fetching: { ...state.fetching, updateBusiness: { ...DEFAULT_FETCHING_STATE } },
                error: { ...DEFAULT_NO_ERROR },
            };
        case Types.UPDATE_BUSINESS_ERROR:
            return { ...state, fetching: { ...state.fetching, updateBusiness: { ...DEFAULT_FETCHING_STATE } }, error: { timestamp: Date.now(), message: action.payload } };

        case Types.UPDATE_BUSINESS_STATUS_START:
            return { ...state, fetching: { ...state.fetching, updateBusinessStatus: { ...DEFAULT_FETCHING_STATE, state: true } } };
        case Types.UPDATE_BUSINESS_STATUS_SUCCESS:
            return { ...state, fetching: { ...state.fetching, updateBusinessStatus: { ...DEFAULT_FETCHING_STATE } }, error: { ...DEFAULT_NO_ERROR } };
        case Types.UPDATE_BUSINESS_STATUS_ERROR:
            return { ...state, fetching: { ...state.fetching, updateBusinessStatus: { ...DEFAULT_FETCHING_STATE } }, error: { timestamp: Date.now(), message: action.payload } };

        case Types.CREATE_BUSINESS_START:
            return { ...state, fetching: { ...state.fetching, createBusiness: { ...DEFAULT_FETCHING_STATE, state: true } } };
        case Types.CREATE_BUSINESS_SUCCESS:
            return { ...state, fetching: { ...state.fetching, createBusiness: { ...DEFAULT_FETCHING_STATE } }, error: { ...DEFAULT_NO_ERROR } };
        case Types.CREATE_BUSINESS_ERROR:
            return { ...state, fetching: { ...state.fetching, createBusiness: { ...DEFAULT_FETCHING_STATE } }, error: { timestamp: Date.now(), message: action.payload } };

        case Types.DELETE_BUSINESS_START:
            return { ...state, fetching: { ...state.fetching, deleteBusiness: { ...DEFAULT_FETCHING_STATE, state: true } } };
        case Types.DELETE_BUSINESS_SUCCESS:
            return { ...state, fetching: { ...state.fetching, deleteBusiness: { ...DEFAULT_FETCHING_STATE } }, error: { ...DEFAULT_NO_ERROR } };
        case Types.DELETE_BUSINESS_ERROR:
            return { ...state, fetching: { ...state.fetching, deleteBusiness: { ...DEFAULT_FETCHING_STATE } }, error: { timestamp: Date.now(), message: action.payload } };

        case Types.BULK_DELETE_BUSINESSES_START:
            return { ...state, fetching: { ...state.fetching, bulkDeleteBusinesses: { ...DEFAULT_FETCHING_STATE, state: true } } };
        case Types.BULK_DELETE_BUSINESSES_SUCCESS:
            return { ...state, fetching: { ...state.fetching, bulkDeleteBusinesses: { ...DEFAULT_FETCHING_STATE } }, error: { ...DEFAULT_NO_ERROR } };
        case Types.BULK_DELETE_BUSINESSES_ERROR:
            return { ...state, fetching: { ...state.fetching, bulkDeleteBusinesses: { ...DEFAULT_FETCHING_STATE } }, error: { timestamp: Date.now(), message: action.payload } };

        case Types.BULK_UPDATE_BUSINESS_STATUS_START:
            return { ...state, fetching: { ...state.fetching, bulkUpdateBusinessStatus: { ...DEFAULT_FETCHING_STATE, state: true } } };
        case Types.BULK_UPDATE_BUSINESS_STATUS_SUCCESS:
            return { ...state, fetching: { ...state.fetching, bulkUpdateBusinessStatus: { ...DEFAULT_FETCHING_STATE } }, error: { ...DEFAULT_NO_ERROR } };
        case Types.BULK_UPDATE_BUSINESS_STATUS_ERROR:
            return { ...state, fetching: { ...state.fetching, bulkUpdateBusinessStatus: { ...DEFAULT_FETCHING_STATE } }, error: { timestamp: Date.now(), message: action.payload } };

        case Types.BULK_DELETE_USERS_START:
            return { ...state, fetching: { ...state.fetching, bulkDeleteUsers: { ...DEFAULT_FETCHING_STATE, state: true } } };
        case Types.BULK_DELETE_USERS_SUCCESS:
            return { ...state, fetching: { ...state.fetching, bulkDeleteUsers: { ...DEFAULT_FETCHING_STATE } }, error: { ...DEFAULT_NO_ERROR } };
        case Types.BULK_DELETE_USERS_ERROR:
            return { ...state, fetching: { ...state.fetching, bulkDeleteUsers: { ...DEFAULT_FETCHING_STATE } }, error: { timestamp: Date.now(), message: action.payload } };

        case Types.BULK_TOGGLE_USERS_START:
            return { ...state, fetching: { ...state.fetching, bulkToggleUsers: { ...DEFAULT_FETCHING_STATE, state: true } } };
        case Types.BULK_TOGGLE_USERS_SUCCESS:
            return { ...state, fetching: { ...state.fetching, bulkToggleUsers: { ...DEFAULT_FETCHING_STATE } }, error: { ...DEFAULT_NO_ERROR } };
        case Types.BULK_TOGGLE_USERS_ERROR:
            return { ...state, fetching: { ...state.fetching, bulkToggleUsers: { ...DEFAULT_FETCHING_STATE } }, error: { timestamp: Date.now(), message: action.payload } };

        case Types.CREATE_USER_START:
            return { ...state, fetching: { ...state.fetching, createUser: { ...DEFAULT_FETCHING_STATE, state: true } } };
        case Types.CREATE_USER_SUCCESS:
            return { ...state, fetching: { ...state.fetching, createUser: { ...DEFAULT_FETCHING_STATE } }, error: { ...DEFAULT_NO_ERROR } };
        case Types.CREATE_USER_ERROR:
            return { ...state, fetching: { ...state.fetching, createUser: { ...DEFAULT_FETCHING_STATE } }, error: { timestamp: Date.now(), message: action.payload } };

        case Types.RESTORE_USER_START:
            return { ...state, fetching: { ...state.fetching, restoreUser: { ...DEFAULT_FETCHING_STATE, state: true } } };
        case Types.RESTORE_USER_SUCCESS:
            return { ...state, fetching: { ...state.fetching, restoreUser: { ...DEFAULT_FETCHING_STATE } }, error: { ...DEFAULT_NO_ERROR } };
        case Types.RESTORE_USER_ERROR:
            return { ...state, fetching: { ...state.fetching, restoreUser: { ...DEFAULT_FETCHING_STATE } }, error: { timestamp: Date.now(), message: action.payload } };

        default:
            return state;
    }
};

export default reducer;
